module.exports = __webpack_public_path__ + "static/media/icon-next.a7b9e9c3.svg";